"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
// import {useTranslation} from "react-i18next";
var routes_1 = require("./routes");
function AuthRoute(_a) {
    var _b;
    var Component = _a.Component, path = _a.path, _c = _a.exact, exact = _c === void 0 ? false : _c, requiredRoles = _a.requiredRoles, user = _a.user;
    var filtredRole = (_b = user === null || user === void 0 ? void 0 : user.roles) === null || _b === void 0 ? void 0 : _b.filter(function (l) {
        return requiredRoles.includes(l.name);
    });
    return (react_1.default.createElement(react_router_dom_1.Route, { exact: exact, path: path, render: function (props) {
            return user.token && filtredRole && filtredRole.length > 0 ? (react_1.default.createElement(Component, __assign({}, props))) : (react_1.default.createElement(react_router_dom_1.Redirect, { to: {
                    pathname: (user === null || user === void 0 ? void 0 : user.roles) && filtredRole && filtredRole.length > 0
                        ? routes_1.NonAuthRoutes.login
                        : routes_1.NonAuthRoutes.unauthorized,
                } }));
        } }));
}
exports.default = AuthRoute;
